module.exports = __webpack_public_path__ + "static/img/yImg.d24dea86.png";